import React from 'react';
import { useSelector } from 'react-redux';
import cls from './EstimateMeasurementsModalComment.module.css';
import { TextArea } from '../../../../components/newUI/TextArea/TextArea';
import { useTranslation } from 'react-i18next';

export const EstimateMeasurementsModalComment = () => {
    const { comment } = useSelector((state) => state.measurementsReducer.calculations);
    const { t } = useTranslation();
    if (comment.length === 0) {
        return null;
    }

    return (
        <div className={cls.container}>
            <TextArea
                label={t('EstimateMeasurementsModalComment.return.TextArea.label')}
                classes={cls.MeasurementComment}
                value={comment}
                readOnly
            />
        </div>
    );
};
